"use client";

import { Progress as BaseProgress } from "@base-ui/react/progress";
import { cn } from "@shared/lib/cn";
import type * as React from "react";

function Progress({ className, value, ...props }: React.ComponentProps<typeof BaseProgress.Root>) {
  return (
    <BaseProgress.Root
      data-slot="progress"
      className={cn("bg-primary/20 relative h-2 w-full overflow-hidden rounded-full", className)}
      value={value ?? null}
      {...props}
    >
      <BaseProgress.Track className="size-full">
        <BaseProgress.Indicator data-slot="progress-indicator" className="bg-primary h-full">
          {/* Base UI handles width internally; keep a translate fallback for visual parity */}
          <span className="block h-full w-full" style={{ transform: `translateX(-${100 - (value || 0)}%)` }} />
        </BaseProgress.Indicator>
      </BaseProgress.Track>
    </BaseProgress.Root>
  );
}

export { Progress };
